import axios from 'axios';
import { apiUrl } from "../constans";
const documents = {
    namespaced: true,
    state: {
        documentType: '',
    },

    mutations: {
        setDocumentType(state, documentType) {
            state.documentType = documentType;
        },

    },

    getters: {
        getDocumentType(state) {
            return state.documentType;
        },
    },

    actions: {
        getDocuementType({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${apiUrl}/document-type`)
                    .then(response => {
                        const token = response.data;
                        commit('setAccessToken', token.access_token);
                    })
                    .catch(error => {
                        console.error(error);
                        reject(error);
                    });
            });

        },

    }
}

export default documents;
